<!--
@Author: Tom Voorneveld <tom>
@Date:   2017-11-23T10:36:37+01:00
@Email:  tom@lorinthe.com
@Project: Lorinthe Language switcher
@Last modified by:   tom
@Last modified time: 2019-05-11T13:39:18+02:00
@Copyright: (c) copyright Lorinthe BV, all rights reserved

Example:     <currency-switcher :curencies="['eur', 'gbp', 'usd']" :show-full="true" class="pl-4"/>

-->

<template>
  <div class="currency-switcher">
    <!-- {{ initLocale() }} -->
    <b-nav-item-dropdown :dropup="dropup" :text="dropdownLbl" right>
      <b-dropdown-item
        v-for="currency in currencies"
        :key="currency.id"
        :class="{ 'is-current': currency === activeCurrency }"
        class="currency-link"
        href="#"
        @click="setCurrency(currency)">
        {{ getCurrencyString(currency) }}
      </b-dropdown-item>
    </b-nav-item-dropdown>
  </div>
</template>

<script>
import Conf from '@/config/settings'

export default {
  props: {
    currencies: { type: Array, default: () => ['en'] },
    showFull: { type: Boolean, default: false },
    dropup: { type: Boolean, default: false },
    currLabel: { type: String, default: '' }
  },
  computed: {
    dropdownLbl: function () {
      return this.currLabel ? Conf.currency.rates[this.currLabel].symbol : Conf.currency.rates[this.activeCurrency].symbol
    },
    activeCurrency: function () {
      return this.$store.getters['app/setting']('currency')
    }
  },
  methods: {
    setCurrency: function (currency) {
      this.$store.commit('app/setting', { set: 'currency', value: currency })
    },
    getCurrencyString: function (currency) {
      return this.showFull ? Conf.currency.rates[currency].symbol + ' - ' + Conf.currency.rates[currency].string : currency
    }
  }
}
</script>

<style lang="scss">

.currency-switcher {
  display: inline-block;
  .dropdown-menu {
    font-size: 0.7em !important;
    padding: 2px;
    text-transform: uppercase;
  }
}

</style>
